import { CONTACT_FORM_ALIAS_PATTERN, CONTACT_FORM_FIELD_TYPES } from './constants';
import type { ContactFormField } from './types';
import type { TranslationCatalog } from './widget-translations';

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const parseContactFormFields = (value: unknown): ContactFormField[] => {
  if (!Array.isArray(value)) return [];
  const aliases = new Set<string>();

  return value.flatMap((item) => {
    if (
      !isRecord(item) ||
      typeof item.alias !== 'string' ||
      !CONTACT_FORM_ALIAS_PATTERN.test(item.alias) ||
      aliases.has(item.alias) ||
      typeof item.type !== 'string' ||
      !CONTACT_FORM_FIELD_TYPES.includes(item.type as ContactFormField['type']) ||
      typeof item.label !== 'string' ||
      !item.label.trim() ||
      typeof item.required !== 'boolean'
    ) {
      return [];
    }
    aliases.add(item.alias);

    return [
      {
        alias: item.alias,
        type: item.type as ContactFormField['type'],
        label: item.label,
        placeholder: typeof item.placeholder === 'string' ? item.placeholder : null,
        required: item.required,
        options: Array.isArray(item.options)
          ? item.options.filter((option): option is string => typeof option === 'string')
          : [],
      },
    ];
  });
};

export const getDefaultContactFormFields = (
  translations: TranslationCatalog,
): ContactFormField[] => [
  {
    alias: 'name',
    type: 'text',
    label: translations.authNamePlaceholder,
    placeholder: translations.authNamePlaceholder,
    required: true,
    options: [],
  },
  {
    alias: 'phone',
    type: 'phone',
    label: translations.authPhonePlaceholder,
    placeholder: translations.authPhonePlaceholder,
    required: true,
    options: [],
  },
];

export const ensureDefaultContactFormFields = (
  fields: ContactFormField[],
  translations: TranslationCatalog,
): ContactFormField[] => (fields.length === 0 ? getDefaultContactFormFields(translations) : fields);
